export const useFeatureFlag = (featureFlagName?: string) => {
  if (!featureFlagName) {
    return false;
  }

  return theme.featureFlags[featureFlagName] ?? false;
};
